var _ellipse, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSorceMapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.619,
    cy: 18.1904,
    rx: 7.61905,
    ry: 3.80952,
    fill: "#FCCC75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2087 8.62829C18.2087 13.7836 11.5804 18.2025 11.5804 18.2025C11.5804 18.2025 4.95215 13.7836 4.95215 8.62829C4.95215 4.96759 7.91974 2 11.5804 2C15.2411 2 18.2087 4.96759 18.2087 8.62829V8.62829Z",
    fill: "#FF8800",
    stroke: "#FF8800",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5815 10.8388C12.8017 10.8388 13.7909 9.84959 13.7909 8.62935C13.7909 7.40912 12.8017 6.41992 11.5815 6.41992C10.3613 6.41992 9.37207 7.40912 9.37207 8.62935C9.37207 9.84959 10.3613 10.8388 11.5815 10.8388Z",
    fill: "#FCCC75",
    stroke: "#FCCC75",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorceMapIcon);
export default __webpack_public_path__ + "static/media/sorceMapIcon.e906178c8ded819d2f3261eea653cadf.svg";
export { ForwardRef as ReactComponent };